var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"va-tab",class:{
    'va-tab--active': _vm.isActive,
    'va-tab--disabled': _vm.disabled
  },on:{"click":function($event){return _vm.$emit('tabClick', !_vm.isActive)}}},[_c('div',{ref:"content",staticClass:"va-tab__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }